const BOX =
  "font-sans text-xs tracking-[-0.01em] text-stears_black bg-white dark:text-[#E5E7EB] dark:bg-[#1F2937]"

const MENU =
  "z-20 border-[0.5px] border-[#4B5563] bg-white py-2 text-xs shadow-sm dark:bg-[#1A1D21]"

export const FIELD_HEIGHT = "h-[33px]"

const OPTION =
  "cursor-pointer whitespace-nowrap px-2.5 py-2 hover:bg-gray-50 dark:text-stears_white dark:hover:bg-[#1F2937]"

const SHARED_PARTS = {
  control: () => "flex h-full !min-h-0 items-center gap-2.5 px-2.5",
  valueContainer: () => "relative grid flex-1 items-center overflow-hidden",
  placeholder: () => "text-xs text-[#9CA3AF]",
  singleValue: () => "text-stears_black dark:text-[#E5E7EB]",
  input: () => "text-stears_black dark:text-[#E5E7EB]",
  indicatorSeparator: () => "hidden",
  indicatorsContainer: () => "text-[#9CA3AF] [&_svg]:h-3 [&_svg]:w-3",
  menuList: () => "max-h-[280px] overflow-y-auto",
  option: () => OPTION,
  noOptionsMessage: () => "px-2.5 py-2 text-[#9CA3AF]",
  loadingMessage: () => "px-2.5 py-2 text-[#9CA3AF]"
}

export const PROMPT_MENU_CLASS_NAMES = {
  menu: () =>
    "z-20 w-full border-[0.5px] border-[#4B5563] bg-white text-xs shadow-sm dark:bg-[#1A1D21]",
  menuList: () => "no-scrollbar overflow-y-auto py-2"
}

export const PROMPT_MENU_HEIGHT = 152

export const SELECT_CLASS_NAMES = {
  ...SHARED_PARTS,
  container: () =>
    `${BOX} ${FIELD_HEIGHT} w-full border-[0.5px] border-[#4B5563]`,
  menu: () => `${MENU} w-full`
}

export const EMBEDDED_SELECT_CLASS_NAMES = {
  ...SHARED_PARTS,
  container: () =>
    `${BOX} ${FIELD_HEIGHT} !static w-auto shrink-0 border-y-[0.5px] border-l-[0.5px] border-[#4B5563]`,
  menu: () => `${MENU} !left-0 !w-full`
}

export const PHONE_DIVIDER_WRAPPER_CLASSES = `${BOX} ${FIELD_HEIGHT} flex shrink-0 items-center border-y-[0.5px] border-[#4B5563]`
export const PHONE_DIVIDER_CLASSES = "h-4 w-px bg-[#4B5563]"

const TEXT_INPUT_BOX = [
  "w-full",
  "!h-[33px]",
  "!py-2",
  "!indent-2.5",
  "!text-xs",
  "!tracking-[-0.01em]",
  "placeholder:!text-xs",
  "placeholder:!text-[#9CA3AF]"
]

export const TEXT_INPUT_CLASSES = [...TEXT_INPUT_BOX, "!border-l-0"]

export const SPECIFY_INPUT_CLASSES = [
  ...TEXT_INPUT_BOX,
  "focus:!border-[#85BEFF]"
]
